import { Fragment } from 'react';
import PageHeader from '../../../layout/shared/page-header';
import { menuRoutes } from '../../../router/menu';
import FacilitatorTotalCalls from './FacilitatorTotalCalls';

const FacilitatorTotalCallsWrapper = () => {
    return (
        <Fragment>
            <PageHeader
                title="Llamadas totales"
                breadcrumb={[
                    { name: 'Ventas' },
                    { name: 'Gestión de campañas' },
                    { name: 'Llamadas totales', href: menuRoutes.calls.path + menuRoutes.calls.total },
                ]}
            />
            <FacilitatorTotalCalls />
        </Fragment>
    );
};

export default FacilitatorTotalCallsWrapper;
